/* eslint-disable */
import { Timestamp } from "../../../google/protobuf/timestamp";
import { AgentLead } from "../../agents/data/agentlead";
import { Listing } from "./listing";

export const protobufPackage = "od_protos.listings.data";

export enum ListingPresentationType {
  UNKNOWN_PRESENTATION_TYPE = 0,
  IN_PERSON = 1,
  VIDEO_CALL = 2,
  PHONE = 3,
  EMAIL = 4,
  UNRECOGNIZED = -1,
}

export function listingPresentationTypeFromJSON(object: any): ListingPresentationType {
  switch (object) {
    case 0:
    case "UNKNOWN_PRESENTATION_TYPE":
      return ListingPresentationType.UNKNOWN_PRESENTATION_TYPE;
    case 1:
    case "IN_PERSON":
      return ListingPresentationType.IN_PERSON;
    case 2:
    case "VIDEO_CALL":
      return ListingPresentationType.VIDEO_CALL;
    case 3:
    case "PHONE":
      return ListingPresentationType.PHONE;
    case 4:
    case "EMAIL":
      return ListingPresentationType.EMAIL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ListingPresentationType.UNRECOGNIZED;
  }
}

export function listingPresentationTypeToJSON(object: ListingPresentationType): string {
  switch (object) {
    case ListingPresentationType.UNKNOWN_PRESENTATION_TYPE:
      return "UNKNOWN_PRESENTATION_TYPE";
    case ListingPresentationType.IN_PERSON:
      return "IN_PERSON";
    case ListingPresentationType.VIDEO_CALL:
      return "VIDEO_CALL";
    case ListingPresentationType.PHONE:
      return "PHONE";
    case ListingPresentationType.EMAIL:
      return "EMAIL";
    case ListingPresentationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** @deprecated */
export enum FinalOfferPresentationType {
  FINAL_OFFER_PRESENTATION_TYPE_UNKNOWN = 0,
  FINAL_OFFER_PRESENTATION_TYPE_IN_PERSON = 1,
  FINAL_OFFER_PRESENTATION_TYPE_VIDEO_CALL = 2,
  FINAL_OFFER_PRESENTATION_TYPE_PHONE = 3,
  FINAL_OFFER_PRESENTATION_TYPE_EMAIL = 4,
  UNRECOGNIZED = -1,
}

export function finalOfferPresentationTypeFromJSON(object: any): FinalOfferPresentationType {
  switch (object) {
    case 0:
    case "FINAL_OFFER_PRESENTATION_TYPE_UNKNOWN":
      return FinalOfferPresentationType.FINAL_OFFER_PRESENTATION_TYPE_UNKNOWN;
    case 1:
    case "FINAL_OFFER_PRESENTATION_TYPE_IN_PERSON":
      return FinalOfferPresentationType.FINAL_OFFER_PRESENTATION_TYPE_IN_PERSON;
    case 2:
    case "FINAL_OFFER_PRESENTATION_TYPE_VIDEO_CALL":
      return FinalOfferPresentationType.FINAL_OFFER_PRESENTATION_TYPE_VIDEO_CALL;
    case 3:
    case "FINAL_OFFER_PRESENTATION_TYPE_PHONE":
      return FinalOfferPresentationType.FINAL_OFFER_PRESENTATION_TYPE_PHONE;
    case 4:
    case "FINAL_OFFER_PRESENTATION_TYPE_EMAIL":
      return FinalOfferPresentationType.FINAL_OFFER_PRESENTATION_TYPE_EMAIL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FinalOfferPresentationType.UNRECOGNIZED;
  }
}

export function finalOfferPresentationTypeToJSON(object: FinalOfferPresentationType): string {
  switch (object) {
    case FinalOfferPresentationType.FINAL_OFFER_PRESENTATION_TYPE_UNKNOWN:
      return "FINAL_OFFER_PRESENTATION_TYPE_UNKNOWN";
    case FinalOfferPresentationType.FINAL_OFFER_PRESENTATION_TYPE_IN_PERSON:
      return "FINAL_OFFER_PRESENTATION_TYPE_IN_PERSON";
    case FinalOfferPresentationType.FINAL_OFFER_PRESENTATION_TYPE_VIDEO_CALL:
      return "FINAL_OFFER_PRESENTATION_TYPE_VIDEO_CALL";
    case FinalOfferPresentationType.FINAL_OFFER_PRESENTATION_TYPE_PHONE:
      return "FINAL_OFFER_PRESENTATION_TYPE_PHONE";
    case FinalOfferPresentationType.FINAL_OFFER_PRESENTATION_TYPE_EMAIL:
      return "FINAL_OFFER_PRESENTATION_TYPE_EMAIL";
    case FinalOfferPresentationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum NoteType {
  UNKNOWN_NOTE = 0,
  AGENT_NOTE = 1,
  CEP_NOTE = 2,
  LEAD_PASS_BACK_NOTE = 3,
  UNRECOGNIZED = -1,
}

export function noteTypeFromJSON(object: any): NoteType {
  switch (object) {
    case 0:
    case "UNKNOWN_NOTE":
      return NoteType.UNKNOWN_NOTE;
    case 1:
    case "AGENT_NOTE":
      return NoteType.AGENT_NOTE;
    case 2:
    case "CEP_NOTE":
      return NoteType.CEP_NOTE;
    case 3:
    case "LEAD_PASS_BACK_NOTE":
      return NoteType.LEAD_PASS_BACK_NOTE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NoteType.UNRECOGNIZED;
  }
}

export function noteTypeToJSON(object: NoteType): string {
  switch (object) {
    case NoteType.UNKNOWN_NOTE:
      return "UNKNOWN_NOTE";
    case NoteType.AGENT_NOTE:
      return "AGENT_NOTE";
    case NoteType.CEP_NOTE:
      return "CEP_NOTE";
    case NoteType.LEAD_PASS_BACK_NOTE:
      return "LEAD_PASS_BACK_NOTE";
    case NoteType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Actor {
  UNKNOWN_ACTOR = 0,
  AGENT = 1,
  CEP = 2,
  SYSTEM = 3,
  UNRECOGNIZED = -1,
}

export function actorFromJSON(object: any): Actor {
  switch (object) {
    case 0:
    case "UNKNOWN_ACTOR":
      return Actor.UNKNOWN_ACTOR;
    case 1:
    case "AGENT":
      return Actor.AGENT;
    case 2:
    case "CEP":
      return Actor.CEP;
    case 3:
    case "SYSTEM":
      return Actor.SYSTEM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Actor.UNRECOGNIZED;
  }
}

export function actorToJSON(object: Actor): string {
  switch (object) {
    case Actor.UNKNOWN_ACTOR:
      return "UNKNOWN_ACTOR";
    case Actor.AGENT:
      return "AGENT";
    case Actor.CEP:
      return "CEP";
    case Actor.SYSTEM:
      return "SYSTEM";
    case Actor.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ExperiencePartnerSupportRequestType {
  UNKNOWN_SUPPORT_REQUEST_TYPE = 0,
  SUPPORT_REQUEST_TYPE_REPAIR_ASKS = 1,
  SUPPORT_REQUEST_TYPE_OFFER_EXPLORATION = 2,
  SUPPORT_REQUEST_TYPE_SELLER_CONTACT = 3,
  SUPPORT_REQUEST_TYPE_SELLER_AGENT_INTRODUCTION = 4,
  SUPPORT_REQUEST_TYPE_FINAL_OFFER_DISCUSSIOON_WITH_SELLER = 5,
  UNRECOGNIZED = -1,
}

export function experiencePartnerSupportRequestTypeFromJSON(object: any): ExperiencePartnerSupportRequestType {
  switch (object) {
    case 0:
    case "UNKNOWN_SUPPORT_REQUEST_TYPE":
      return ExperiencePartnerSupportRequestType.UNKNOWN_SUPPORT_REQUEST_TYPE;
    case 1:
    case "SUPPORT_REQUEST_TYPE_REPAIR_ASKS":
      return ExperiencePartnerSupportRequestType.SUPPORT_REQUEST_TYPE_REPAIR_ASKS;
    case 2:
    case "SUPPORT_REQUEST_TYPE_OFFER_EXPLORATION":
      return ExperiencePartnerSupportRequestType.SUPPORT_REQUEST_TYPE_OFFER_EXPLORATION;
    case 3:
    case "SUPPORT_REQUEST_TYPE_SELLER_CONTACT":
      return ExperiencePartnerSupportRequestType.SUPPORT_REQUEST_TYPE_SELLER_CONTACT;
    case 4:
    case "SUPPORT_REQUEST_TYPE_SELLER_AGENT_INTRODUCTION":
      return ExperiencePartnerSupportRequestType.SUPPORT_REQUEST_TYPE_SELLER_AGENT_INTRODUCTION;
    case 5:
    case "SUPPORT_REQUEST_TYPE_FINAL_OFFER_DISCUSSIOON_WITH_SELLER":
      return ExperiencePartnerSupportRequestType.SUPPORT_REQUEST_TYPE_FINAL_OFFER_DISCUSSIOON_WITH_SELLER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ExperiencePartnerSupportRequestType.UNRECOGNIZED;
  }
}

export function experiencePartnerSupportRequestTypeToJSON(object: ExperiencePartnerSupportRequestType): string {
  switch (object) {
    case ExperiencePartnerSupportRequestType.UNKNOWN_SUPPORT_REQUEST_TYPE:
      return "UNKNOWN_SUPPORT_REQUEST_TYPE";
    case ExperiencePartnerSupportRequestType.SUPPORT_REQUEST_TYPE_REPAIR_ASKS:
      return "SUPPORT_REQUEST_TYPE_REPAIR_ASKS";
    case ExperiencePartnerSupportRequestType.SUPPORT_REQUEST_TYPE_OFFER_EXPLORATION:
      return "SUPPORT_REQUEST_TYPE_OFFER_EXPLORATION";
    case ExperiencePartnerSupportRequestType.SUPPORT_REQUEST_TYPE_SELLER_CONTACT:
      return "SUPPORT_REQUEST_TYPE_SELLER_CONTACT";
    case ExperiencePartnerSupportRequestType.SUPPORT_REQUEST_TYPE_SELLER_AGENT_INTRODUCTION:
      return "SUPPORT_REQUEST_TYPE_SELLER_AGENT_INTRODUCTION";
    case ExperiencePartnerSupportRequestType.SUPPORT_REQUEST_TYPE_FINAL_OFFER_DISCUSSIOON_WITH_SELLER:
      return "SUPPORT_REQUEST_TYPE_FINAL_OFFER_DISCUSSIOON_WITH_SELLER";
    case ExperiencePartnerSupportRequestType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SelectedProduct {
  SELECTED_PRODUCT_UNKNOWN = 0,
  SELECTED_PRODUCT_LIST_WITH_CERTAINTY = 1,
  SELECTED_PRODUCT_OPENDOOR_DIRECT = 2,
  SELECTED_PRODUCT_SELL_WITH_UPSIDE = 3,
  UNRECOGNIZED = -1,
}

export function selectedProductFromJSON(object: any): SelectedProduct {
  switch (object) {
    case 0:
    case "SELECTED_PRODUCT_UNKNOWN":
      return SelectedProduct.SELECTED_PRODUCT_UNKNOWN;
    case 1:
    case "SELECTED_PRODUCT_LIST_WITH_CERTAINTY":
      return SelectedProduct.SELECTED_PRODUCT_LIST_WITH_CERTAINTY;
    case 2:
    case "SELECTED_PRODUCT_OPENDOOR_DIRECT":
      return SelectedProduct.SELECTED_PRODUCT_OPENDOOR_DIRECT;
    case 3:
    case "SELECTED_PRODUCT_SELL_WITH_UPSIDE":
      return SelectedProduct.SELECTED_PRODUCT_SELL_WITH_UPSIDE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SelectedProduct.UNRECOGNIZED;
  }
}

export function selectedProductToJSON(object: SelectedProduct): string {
  switch (object) {
    case SelectedProduct.SELECTED_PRODUCT_UNKNOWN:
      return "SELECTED_PRODUCT_UNKNOWN";
    case SelectedProduct.SELECTED_PRODUCT_LIST_WITH_CERTAINTY:
      return "SELECTED_PRODUCT_LIST_WITH_CERTAINTY";
    case SelectedProduct.SELECTED_PRODUCT_OPENDOOR_DIRECT:
      return "SELECTED_PRODUCT_OPENDOOR_DIRECT";
    case SelectedProduct.SELECTED_PRODUCT_SELL_WITH_UPSIDE:
      return "SELECTED_PRODUCT_SELL_WITH_UPSIDE";
    case SelectedProduct.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** @deprecated */
export enum FinalOfferPresentationStatus {
  UNKNOWN = 0,
  PENDING_GENERATION = 1,
  NOT_PRESENTED = 2,
  AGENT_PRESENTED = 3,
  REMINDED_AGENT = 4,
  REQUESTED_EP = 5,
  EP_PRESENTED = 6,
  UNRECOGNIZED = -1,
}

export function finalOfferPresentationStatusFromJSON(object: any): FinalOfferPresentationStatus {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return FinalOfferPresentationStatus.UNKNOWN;
    case 1:
    case "PENDING_GENERATION":
      return FinalOfferPresentationStatus.PENDING_GENERATION;
    case 2:
    case "NOT_PRESENTED":
      return FinalOfferPresentationStatus.NOT_PRESENTED;
    case 3:
    case "AGENT_PRESENTED":
      return FinalOfferPresentationStatus.AGENT_PRESENTED;
    case 4:
    case "REMINDED_AGENT":
      return FinalOfferPresentationStatus.REMINDED_AGENT;
    case 5:
    case "REQUESTED_EP":
      return FinalOfferPresentationStatus.REQUESTED_EP;
    case 6:
    case "EP_PRESENTED":
      return FinalOfferPresentationStatus.EP_PRESENTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FinalOfferPresentationStatus.UNRECOGNIZED;
  }
}

export function finalOfferPresentationStatusToJSON(object: FinalOfferPresentationStatus): string {
  switch (object) {
    case FinalOfferPresentationStatus.UNKNOWN:
      return "UNKNOWN";
    case FinalOfferPresentationStatus.PENDING_GENERATION:
      return "PENDING_GENERATION";
    case FinalOfferPresentationStatus.NOT_PRESENTED:
      return "NOT_PRESENTED";
    case FinalOfferPresentationStatus.AGENT_PRESENTED:
      return "AGENT_PRESENTED";
    case FinalOfferPresentationStatus.REMINDED_AGENT:
      return "REMINDED_AGENT";
    case FinalOfferPresentationStatus.REQUESTED_EP:
      return "REQUESTED_EP";
    case FinalOfferPresentationStatus.EP_PRESENTED:
      return "EP_PRESENTED";
    case FinalOfferPresentationStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface KeyTimestampPair {
  key: string;
  timestamp?: Date | undefined;
}

/** Next ID: 33 */
export interface LwcProduct {
  id: string;
  state: LwcProduct_State;
  sellerLeadToken: string;
  listingId: string;
  assignedAgentId: string;
  agentNote: string;
  cepNote: string;
  leadPassBackNote: string;
  timestamps: KeyTimestampPair[];
  presentationType: ListingPresentationType;
  /** @deprecated */
  finalOfferPresentationType: FinalOfferPresentationType;
  inAgentLedOffersExperience: boolean;
  listingEstimatePricingsId: string;
  sellerLeadUuid: string;
  /** current_product_selected is used in lwcProductView; can replace with data from Indextrious in the future */
  currentProductSelected: SelectedProduct;
  /** assessment_completed_at is used in lwcProductView; can replace with data from Indextrious in the future */
  assessmentCompletedAt?: Date | undefined;
  addressUuid: string;
  /** @deprecated */
  finalOfferPresentationInfo?: FinalOfferPresentationInfo | undefined;
}

/** Next ID: 31 */
export enum LwcProduct_State {
  UNKNOWN = 0,
  CREATED = 1,
  /** @deprecated */
  LISTING_INITIATED = 2,
  /** @deprecated */
  FIRST_CONTACT_ATTEMPTED = 4,
  /** @deprecated */
  LISTING_PRESENTATION_SCHEDULED = 5,
  /** @deprecated */
  LISTING_PRESENTATION_COMPLETE = 6,
  /** @deprecated */
  SELECTED_LISTING = 19,
  /** @deprecated */
  SELECTED_DIRECT_SALE = 20,
  /** @deprecated */
  SELECTED_SELL_WITH_UPSIDE = 28,
  /** @deprecated */
  FIRST_CONTACT_MADE = 22,
  /** @deprecated */
  ASSESSMENT_SCHEDULED = 23,
  /** @deprecated */
  ASSESSMENT_COMPLETE = 24,
  /** @deprecated */
  FINAL_OFFER_PRESENTATION_SCHEDULED = 26,
  /** @deprecated */
  FINAL_OFFER_PRESENTATION_COMPLETE = 25,
  LISTING_AGREEMENT_SIGNED = 29,
  /** NOT_ELIGIBLE - Terminal */
  NOT_ELIGIBLE = 16,
  /** @deprecated */
  SOLD_ON_MARKET = 13,
  /** @deprecated */
  SOLD_TO_OPENDOOR = 17,
  /** @deprecated */
  NO_SALE = 18,
  CLOSED = 30,
  /**
   * DNC_NOT_BUYING_SELLING - Did not convert (DNC)
   *
   * @deprecated
   */
  DNC_NOT_BUYING_SELLING = 9,
  /** @deprecated */
  DNC_COMPETITOR = 10,
  /** @deprecated */
  DNC_NON_RESPONSIVE = 11,
  /** @deprecated */
  DNC_NOT_INTERESTED = 14,
  /** @deprecated */
  DNC_DIRECT_SALE_ONLY = 15,
  /**
   * AGENT_ASSIGNED - Deprecated
   *
   * @deprecated
   */
  AGENT_ASSIGNED = 3,
  /** @deprecated */
  DELETED = 12,
  /** @deprecated */
  CONVERTED_LISTING = 7,
  /** @deprecated */
  CONVERTED_DIRECT_SALE = 8,
  UNRECOGNIZED = -1,
}

export function lwcProduct_StateFromJSON(object: any): LwcProduct_State {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return LwcProduct_State.UNKNOWN;
    case 1:
    case "CREATED":
      return LwcProduct_State.CREATED;
    case 2:
    case "LISTING_INITIATED":
      return LwcProduct_State.LISTING_INITIATED;
    case 4:
    case "FIRST_CONTACT_ATTEMPTED":
      return LwcProduct_State.FIRST_CONTACT_ATTEMPTED;
    case 5:
    case "LISTING_PRESENTATION_SCHEDULED":
      return LwcProduct_State.LISTING_PRESENTATION_SCHEDULED;
    case 6:
    case "LISTING_PRESENTATION_COMPLETE":
      return LwcProduct_State.LISTING_PRESENTATION_COMPLETE;
    case 19:
    case "SELECTED_LISTING":
      return LwcProduct_State.SELECTED_LISTING;
    case 20:
    case "SELECTED_DIRECT_SALE":
      return LwcProduct_State.SELECTED_DIRECT_SALE;
    case 28:
    case "SELECTED_SELL_WITH_UPSIDE":
      return LwcProduct_State.SELECTED_SELL_WITH_UPSIDE;
    case 22:
    case "FIRST_CONTACT_MADE":
      return LwcProduct_State.FIRST_CONTACT_MADE;
    case 23:
    case "ASSESSMENT_SCHEDULED":
      return LwcProduct_State.ASSESSMENT_SCHEDULED;
    case 24:
    case "ASSESSMENT_COMPLETE":
      return LwcProduct_State.ASSESSMENT_COMPLETE;
    case 26:
    case "FINAL_OFFER_PRESENTATION_SCHEDULED":
      return LwcProduct_State.FINAL_OFFER_PRESENTATION_SCHEDULED;
    case 25:
    case "FINAL_OFFER_PRESENTATION_COMPLETE":
      return LwcProduct_State.FINAL_OFFER_PRESENTATION_COMPLETE;
    case 29:
    case "LISTING_AGREEMENT_SIGNED":
      return LwcProduct_State.LISTING_AGREEMENT_SIGNED;
    case 16:
    case "NOT_ELIGIBLE":
      return LwcProduct_State.NOT_ELIGIBLE;
    case 13:
    case "SOLD_ON_MARKET":
      return LwcProduct_State.SOLD_ON_MARKET;
    case 17:
    case "SOLD_TO_OPENDOOR":
      return LwcProduct_State.SOLD_TO_OPENDOOR;
    case 18:
    case "NO_SALE":
      return LwcProduct_State.NO_SALE;
    case 30:
    case "CLOSED":
      return LwcProduct_State.CLOSED;
    case 9:
    case "DNC_NOT_BUYING_SELLING":
      return LwcProduct_State.DNC_NOT_BUYING_SELLING;
    case 10:
    case "DNC_COMPETITOR":
      return LwcProduct_State.DNC_COMPETITOR;
    case 11:
    case "DNC_NON_RESPONSIVE":
      return LwcProduct_State.DNC_NON_RESPONSIVE;
    case 14:
    case "DNC_NOT_INTERESTED":
      return LwcProduct_State.DNC_NOT_INTERESTED;
    case 15:
    case "DNC_DIRECT_SALE_ONLY":
      return LwcProduct_State.DNC_DIRECT_SALE_ONLY;
    case 3:
    case "AGENT_ASSIGNED":
      return LwcProduct_State.AGENT_ASSIGNED;
    case 12:
    case "DELETED":
      return LwcProduct_State.DELETED;
    case 7:
    case "CONVERTED_LISTING":
      return LwcProduct_State.CONVERTED_LISTING;
    case 8:
    case "CONVERTED_DIRECT_SALE":
      return LwcProduct_State.CONVERTED_DIRECT_SALE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LwcProduct_State.UNRECOGNIZED;
  }
}

export function lwcProduct_StateToJSON(object: LwcProduct_State): string {
  switch (object) {
    case LwcProduct_State.UNKNOWN:
      return "UNKNOWN";
    case LwcProduct_State.CREATED:
      return "CREATED";
    case LwcProduct_State.LISTING_INITIATED:
      return "LISTING_INITIATED";
    case LwcProduct_State.FIRST_CONTACT_ATTEMPTED:
      return "FIRST_CONTACT_ATTEMPTED";
    case LwcProduct_State.LISTING_PRESENTATION_SCHEDULED:
      return "LISTING_PRESENTATION_SCHEDULED";
    case LwcProduct_State.LISTING_PRESENTATION_COMPLETE:
      return "LISTING_PRESENTATION_COMPLETE";
    case LwcProduct_State.SELECTED_LISTING:
      return "SELECTED_LISTING";
    case LwcProduct_State.SELECTED_DIRECT_SALE:
      return "SELECTED_DIRECT_SALE";
    case LwcProduct_State.SELECTED_SELL_WITH_UPSIDE:
      return "SELECTED_SELL_WITH_UPSIDE";
    case LwcProduct_State.FIRST_CONTACT_MADE:
      return "FIRST_CONTACT_MADE";
    case LwcProduct_State.ASSESSMENT_SCHEDULED:
      return "ASSESSMENT_SCHEDULED";
    case LwcProduct_State.ASSESSMENT_COMPLETE:
      return "ASSESSMENT_COMPLETE";
    case LwcProduct_State.FINAL_OFFER_PRESENTATION_SCHEDULED:
      return "FINAL_OFFER_PRESENTATION_SCHEDULED";
    case LwcProduct_State.FINAL_OFFER_PRESENTATION_COMPLETE:
      return "FINAL_OFFER_PRESENTATION_COMPLETE";
    case LwcProduct_State.LISTING_AGREEMENT_SIGNED:
      return "LISTING_AGREEMENT_SIGNED";
    case LwcProduct_State.NOT_ELIGIBLE:
      return "NOT_ELIGIBLE";
    case LwcProduct_State.SOLD_ON_MARKET:
      return "SOLD_ON_MARKET";
    case LwcProduct_State.SOLD_TO_OPENDOOR:
      return "SOLD_TO_OPENDOOR";
    case LwcProduct_State.NO_SALE:
      return "NO_SALE";
    case LwcProduct_State.CLOSED:
      return "CLOSED";
    case LwcProduct_State.DNC_NOT_BUYING_SELLING:
      return "DNC_NOT_BUYING_SELLING";
    case LwcProduct_State.DNC_COMPETITOR:
      return "DNC_COMPETITOR";
    case LwcProduct_State.DNC_NON_RESPONSIVE:
      return "DNC_NON_RESPONSIVE";
    case LwcProduct_State.DNC_NOT_INTERESTED:
      return "DNC_NOT_INTERESTED";
    case LwcProduct_State.DNC_DIRECT_SALE_ONLY:
      return "DNC_DIRECT_SALE_ONLY";
    case LwcProduct_State.AGENT_ASSIGNED:
      return "AGENT_ASSIGNED";
    case LwcProduct_State.DELETED:
      return "DELETED";
    case LwcProduct_State.CONVERTED_LISTING:
      return "CONVERTED_LISTING";
    case LwcProduct_State.CONVERTED_DIRECT_SALE:
      return "CONVERTED_DIRECT_SALE";
    case LwcProduct_State.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** @deprecated */
export interface FinalOfferPresentationInfo {
  finalOfferPresentationStatus: FinalOfferPresentationStatus;
  finalOfferPresentedAt?: Date | undefined;
  finalOfferPresentationType: FinalOfferPresentationType;
}

export interface LwcDetails {
  lwcProduct?: LwcProduct | undefined;
  listing?: Listing | undefined;
  agentLead?: AgentLead | undefined;
}

/** The LwcProductFilter is used to filter LwcProduct list results */
export interface LwcProductFilter {
  /**
   * Only LwcProducts which have a state found in the states list will
   * be returned. If no states filter is provided, all LwcProducts found
   * in an "active" states (i.e. not CREATED or DELETED) will be returned.
   */
  states: LwcProduct_State[];
}

export interface AssignedAgent {
  agentCustomerUuid: string;
  agentId: string;
}

export interface AssignedBrokerage {
  brokerageId: string;
}

export interface LwcProductView {
  id: string;
  intent: LwcProductView_Intent;
  sellDirectLeadToken: string;
  listingAgreementSignedAt?: Date | undefined;
  assignedAgent?:
    | AssignedAgent
    | undefined;
  /** Time when a listing has become active, i.e. listed */
  listingActiveAt?: Date | undefined;
  listingSoldAt?: Date | undefined;
  assignedBrokerage?:
    | AssignedBrokerage
    | undefined;
  /** This is the brokerage most likely to be assigned. */
  proposedBrokerage?:
    | AssignedBrokerage
    | undefined;
  /**
   * For ALO leads, the agent meets with the customer to do assessments
   * this should be the time that meeting is scheduled for
   */
  assessmentScheduledAt?: Date | undefined;
  inAgentLedOffersExperience: boolean;
  /** Timestamp when customer exited the Agent Led Offers experience */
  exitedAloAt?:
    | Date
    | undefined;
  /**
   * Pricings service ID to retrieve the Listing estimates
   * NOTE: add foreign key resolver if necessary
   */
  listingEstimatePricingsId: string;
  /** UUID identifying the seller lead associated with the LwC product */
  sellerLeadUuid: string;
  /** ID of the listing associated with this LwC product */
  listingId: string;
  addressUuid: string;
}

/** Next ID: 8 */
export enum LwcProductView_Intent {
  /** UNSET - Enum value not set, DO NOT USE */
  UNSET = 0,
  /** PENDING - Lead has expressed some intent to list via LwC */
  PENDING = 1,
  /** LISTING_VIA_LWC - Lead has chosen to list via LwC */
  LISTING_VIA_LWC = 2,
  /** DIRECT_SALE_VIA_LWC - Lead has explicitly expressed intent to take the SD offer after listing via LwC */
  DIRECT_SALE_VIA_LWC = 3,
  /** NON_LWC - Lead is qualified for LwC but has declined it */
  NON_LWC = 4,
  /** SELL_WITH_UPSIDE - Lead has explicitly expressed interest in the Sell With Upside offer */
  SELL_WITH_UPSIDE = 5,
  /** NOT_STARTED - Lead is qualified for LwC but we have not yet collected their intent */
  NOT_STARTED = 6,
  /** CLOSED - Lead has closed -- sold through some means and no longer active */
  CLOSED = 7,
  UNRECOGNIZED = -1,
}

export function lwcProductView_IntentFromJSON(object: any): LwcProductView_Intent {
  switch (object) {
    case 0:
    case "UNSET":
      return LwcProductView_Intent.UNSET;
    case 1:
    case "PENDING":
      return LwcProductView_Intent.PENDING;
    case 2:
    case "LISTING_VIA_LWC":
      return LwcProductView_Intent.LISTING_VIA_LWC;
    case 3:
    case "DIRECT_SALE_VIA_LWC":
      return LwcProductView_Intent.DIRECT_SALE_VIA_LWC;
    case 4:
    case "NON_LWC":
      return LwcProductView_Intent.NON_LWC;
    case 5:
    case "SELL_WITH_UPSIDE":
      return LwcProductView_Intent.SELL_WITH_UPSIDE;
    case 6:
    case "NOT_STARTED":
      return LwcProductView_Intent.NOT_STARTED;
    case 7:
    case "CLOSED":
      return LwcProductView_Intent.CLOSED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LwcProductView_Intent.UNRECOGNIZED;
  }
}

export function lwcProductView_IntentToJSON(object: LwcProductView_Intent): string {
  switch (object) {
    case LwcProductView_Intent.UNSET:
      return "UNSET";
    case LwcProductView_Intent.PENDING:
      return "PENDING";
    case LwcProductView_Intent.LISTING_VIA_LWC:
      return "LISTING_VIA_LWC";
    case LwcProductView_Intent.DIRECT_SALE_VIA_LWC:
      return "DIRECT_SALE_VIA_LWC";
    case LwcProductView_Intent.NON_LWC:
      return "NON_LWC";
    case LwcProductView_Intent.SELL_WITH_UPSIDE:
      return "SELL_WITH_UPSIDE";
    case LwcProductView_Intent.NOT_STARTED:
      return "NOT_STARTED";
    case LwcProductView_Intent.CLOSED:
      return "CLOSED";
    case LwcProductView_Intent.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseKeyTimestampPair(): KeyTimestampPair {
  return { key: "", timestamp: undefined };
}

export const KeyTimestampPair = {
  fromJSON(object: any): KeyTimestampPair {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
    };
  },

  toJSON(message: KeyTimestampPair): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeyTimestampPair>, I>>(base?: I): KeyTimestampPair {
    return KeyTimestampPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyTimestampPair>, I>>(object: I): KeyTimestampPair {
    const message = createBaseKeyTimestampPair();
    message.key = object.key ?? "";
    message.timestamp = object.timestamp ?? undefined;
    return message;
  },
};

function createBaseLwcProduct(): LwcProduct {
  return {
    id: "",
    state: 0,
    sellerLeadToken: "",
    listingId: "",
    assignedAgentId: "",
    agentNote: "",
    cepNote: "",
    leadPassBackNote: "",
    timestamps: [],
    presentationType: 0,
    finalOfferPresentationType: 0,
    inAgentLedOffersExperience: false,
    listingEstimatePricingsId: "",
    sellerLeadUuid: "",
    currentProductSelected: 0,
    assessmentCompletedAt: undefined,
    addressUuid: "",
    finalOfferPresentationInfo: undefined,
  };
}

export const LwcProduct = {
  fromJSON(object: any): LwcProduct {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      state: isSet(object.state) ? lwcProduct_StateFromJSON(object.state) : 0,
      sellerLeadToken: isSet(object.sellerLeadToken) ? String(object.sellerLeadToken) : "",
      listingId: isSet(object.listingId) ? String(object.listingId) : "",
      assignedAgentId: isSet(object.assignedAgentId) ? String(object.assignedAgentId) : "",
      agentNote: isSet(object.agentNote) ? String(object.agentNote) : "",
      cepNote: isSet(object.cepNote) ? String(object.cepNote) : "",
      leadPassBackNote: isSet(object.leadPassBackNote) ? String(object.leadPassBackNote) : "",
      timestamps: Array.isArray(object?.timestamps)
        ? object.timestamps.map((e: any) => KeyTimestampPair.fromJSON(e))
        : [],
      presentationType: isSet(object.presentationType) ? listingPresentationTypeFromJSON(object.presentationType) : 0,
      finalOfferPresentationType: isSet(object.finalOfferPresentationType)
        ? finalOfferPresentationTypeFromJSON(object.finalOfferPresentationType)
        : 0,
      inAgentLedOffersExperience: isSet(object.inAgentLedOffersExperience)
        ? Boolean(object.inAgentLedOffersExperience)
        : false,
      listingEstimatePricingsId: isSet(object.listingEstimatePricingsId)
        ? String(object.listingEstimatePricingsId)
        : "",
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      currentProductSelected: isSet(object.currentProductSelected)
        ? selectedProductFromJSON(object.currentProductSelected)
        : 0,
      assessmentCompletedAt: isSet(object.assessmentCompletedAt)
        ? fromJsonTimestamp(object.assessmentCompletedAt)
        : undefined,
      addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
      finalOfferPresentationInfo: isSet(object.finalOfferPresentationInfo)
        ? FinalOfferPresentationInfo.fromJSON(object.finalOfferPresentationInfo)
        : undefined,
    };
  },

  toJSON(message: LwcProduct): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.state !== 0) {
      obj.state = lwcProduct_StateToJSON(message.state);
    }
    if (message.sellerLeadToken !== "") {
      obj.sellerLeadToken = message.sellerLeadToken;
    }
    if (message.listingId !== "") {
      obj.listingId = message.listingId;
    }
    if (message.assignedAgentId !== "") {
      obj.assignedAgentId = message.assignedAgentId;
    }
    if (message.agentNote !== "") {
      obj.agentNote = message.agentNote;
    }
    if (message.cepNote !== "") {
      obj.cepNote = message.cepNote;
    }
    if (message.leadPassBackNote !== "") {
      obj.leadPassBackNote = message.leadPassBackNote;
    }
    if (message.timestamps?.length) {
      obj.timestamps = message.timestamps.map((e) => KeyTimestampPair.toJSON(e));
    }
    if (message.presentationType !== 0) {
      obj.presentationType = listingPresentationTypeToJSON(message.presentationType);
    }
    if (message.finalOfferPresentationType !== 0) {
      obj.finalOfferPresentationType = finalOfferPresentationTypeToJSON(message.finalOfferPresentationType);
    }
    if (message.inAgentLedOffersExperience === true) {
      obj.inAgentLedOffersExperience = message.inAgentLedOffersExperience;
    }
    if (message.listingEstimatePricingsId !== "") {
      obj.listingEstimatePricingsId = message.listingEstimatePricingsId;
    }
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.currentProductSelected !== 0) {
      obj.currentProductSelected = selectedProductToJSON(message.currentProductSelected);
    }
    if (message.assessmentCompletedAt !== undefined) {
      obj.assessmentCompletedAt = message.assessmentCompletedAt.toISOString();
    }
    if (message.addressUuid !== "") {
      obj.addressUuid = message.addressUuid;
    }
    if (message.finalOfferPresentationInfo !== undefined) {
      obj.finalOfferPresentationInfo = FinalOfferPresentationInfo.toJSON(message.finalOfferPresentationInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LwcProduct>, I>>(base?: I): LwcProduct {
    return LwcProduct.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LwcProduct>, I>>(object: I): LwcProduct {
    const message = createBaseLwcProduct();
    message.id = object.id ?? "";
    message.state = object.state ?? 0;
    message.sellerLeadToken = object.sellerLeadToken ?? "";
    message.listingId = object.listingId ?? "";
    message.assignedAgentId = object.assignedAgentId ?? "";
    message.agentNote = object.agentNote ?? "";
    message.cepNote = object.cepNote ?? "";
    message.leadPassBackNote = object.leadPassBackNote ?? "";
    message.timestamps = object.timestamps?.map((e) => KeyTimestampPair.fromPartial(e)) || [];
    message.presentationType = object.presentationType ?? 0;
    message.finalOfferPresentationType = object.finalOfferPresentationType ?? 0;
    message.inAgentLedOffersExperience = object.inAgentLedOffersExperience ?? false;
    message.listingEstimatePricingsId = object.listingEstimatePricingsId ?? "";
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.currentProductSelected = object.currentProductSelected ?? 0;
    message.assessmentCompletedAt = object.assessmentCompletedAt ?? undefined;
    message.addressUuid = object.addressUuid ?? "";
    message.finalOfferPresentationInfo =
      (object.finalOfferPresentationInfo !== undefined && object.finalOfferPresentationInfo !== null)
        ? FinalOfferPresentationInfo.fromPartial(object.finalOfferPresentationInfo)
        : undefined;
    return message;
  },
};

function createBaseFinalOfferPresentationInfo(): FinalOfferPresentationInfo {
  return { finalOfferPresentationStatus: 0, finalOfferPresentedAt: undefined, finalOfferPresentationType: 0 };
}

export const FinalOfferPresentationInfo = {
  fromJSON(object: any): FinalOfferPresentationInfo {
    return {
      finalOfferPresentationStatus: isSet(object.finalOfferPresentationStatus)
        ? finalOfferPresentationStatusFromJSON(object.finalOfferPresentationStatus)
        : 0,
      finalOfferPresentedAt: isSet(object.finalOfferPresentedAt)
        ? fromJsonTimestamp(object.finalOfferPresentedAt)
        : undefined,
      finalOfferPresentationType: isSet(object.finalOfferPresentationType)
        ? finalOfferPresentationTypeFromJSON(object.finalOfferPresentationType)
        : 0,
    };
  },

  toJSON(message: FinalOfferPresentationInfo): unknown {
    const obj: any = {};
    if (message.finalOfferPresentationStatus !== 0) {
      obj.finalOfferPresentationStatus = finalOfferPresentationStatusToJSON(message.finalOfferPresentationStatus);
    }
    if (message.finalOfferPresentedAt !== undefined) {
      obj.finalOfferPresentedAt = message.finalOfferPresentedAt.toISOString();
    }
    if (message.finalOfferPresentationType !== 0) {
      obj.finalOfferPresentationType = finalOfferPresentationTypeToJSON(message.finalOfferPresentationType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FinalOfferPresentationInfo>, I>>(base?: I): FinalOfferPresentationInfo {
    return FinalOfferPresentationInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FinalOfferPresentationInfo>, I>>(object: I): FinalOfferPresentationInfo {
    const message = createBaseFinalOfferPresentationInfo();
    message.finalOfferPresentationStatus = object.finalOfferPresentationStatus ?? 0;
    message.finalOfferPresentedAt = object.finalOfferPresentedAt ?? undefined;
    message.finalOfferPresentationType = object.finalOfferPresentationType ?? 0;
    return message;
  },
};

function createBaseLwcDetails(): LwcDetails {
  return { lwcProduct: undefined, listing: undefined, agentLead: undefined };
}

export const LwcDetails = {
  fromJSON(object: any): LwcDetails {
    return {
      lwcProduct: isSet(object.lwcProduct) ? LwcProduct.fromJSON(object.lwcProduct) : undefined,
      listing: isSet(object.listing) ? Listing.fromJSON(object.listing) : undefined,
      agentLead: isSet(object.agentLead) ? AgentLead.fromJSON(object.agentLead) : undefined,
    };
  },

  toJSON(message: LwcDetails): unknown {
    const obj: any = {};
    if (message.lwcProduct !== undefined) {
      obj.lwcProduct = LwcProduct.toJSON(message.lwcProduct);
    }
    if (message.listing !== undefined) {
      obj.listing = Listing.toJSON(message.listing);
    }
    if (message.agentLead !== undefined) {
      obj.agentLead = AgentLead.toJSON(message.agentLead);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LwcDetails>, I>>(base?: I): LwcDetails {
    return LwcDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LwcDetails>, I>>(object: I): LwcDetails {
    const message = createBaseLwcDetails();
    message.lwcProduct = (object.lwcProduct !== undefined && object.lwcProduct !== null)
      ? LwcProduct.fromPartial(object.lwcProduct)
      : undefined;
    message.listing = (object.listing !== undefined && object.listing !== null)
      ? Listing.fromPartial(object.listing)
      : undefined;
    message.agentLead = (object.agentLead !== undefined && object.agentLead !== null)
      ? AgentLead.fromPartial(object.agentLead)
      : undefined;
    return message;
  },
};

function createBaseLwcProductFilter(): LwcProductFilter {
  return { states: [] };
}

export const LwcProductFilter = {
  fromJSON(object: any): LwcProductFilter {
    return { states: Array.isArray(object?.states) ? object.states.map((e: any) => lwcProduct_StateFromJSON(e)) : [] };
  },

  toJSON(message: LwcProductFilter): unknown {
    const obj: any = {};
    if (message.states?.length) {
      obj.states = message.states.map((e) => lwcProduct_StateToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LwcProductFilter>, I>>(base?: I): LwcProductFilter {
    return LwcProductFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LwcProductFilter>, I>>(object: I): LwcProductFilter {
    const message = createBaseLwcProductFilter();
    message.states = object.states?.map((e) => e) || [];
    return message;
  },
};

function createBaseAssignedAgent(): AssignedAgent {
  return { agentCustomerUuid: "", agentId: "" };
}

export const AssignedAgent = {
  fromJSON(object: any): AssignedAgent {
    return {
      agentCustomerUuid: isSet(object.agentCustomerUuid) ? String(object.agentCustomerUuid) : "",
      agentId: isSet(object.agentId) ? String(object.agentId) : "",
    };
  },

  toJSON(message: AssignedAgent): unknown {
    const obj: any = {};
    if (message.agentCustomerUuid !== "") {
      obj.agentCustomerUuid = message.agentCustomerUuid;
    }
    if (message.agentId !== "") {
      obj.agentId = message.agentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignedAgent>, I>>(base?: I): AssignedAgent {
    return AssignedAgent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignedAgent>, I>>(object: I): AssignedAgent {
    const message = createBaseAssignedAgent();
    message.agentCustomerUuid = object.agentCustomerUuid ?? "";
    message.agentId = object.agentId ?? "";
    return message;
  },
};

function createBaseAssignedBrokerage(): AssignedBrokerage {
  return { brokerageId: "" };
}

export const AssignedBrokerage = {
  fromJSON(object: any): AssignedBrokerage {
    return { brokerageId: isSet(object.brokerageId) ? String(object.brokerageId) : "" };
  },

  toJSON(message: AssignedBrokerage): unknown {
    const obj: any = {};
    if (message.brokerageId !== "") {
      obj.brokerageId = message.brokerageId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignedBrokerage>, I>>(base?: I): AssignedBrokerage {
    return AssignedBrokerage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignedBrokerage>, I>>(object: I): AssignedBrokerage {
    const message = createBaseAssignedBrokerage();
    message.brokerageId = object.brokerageId ?? "";
    return message;
  },
};

function createBaseLwcProductView(): LwcProductView {
  return {
    id: "",
    intent: 0,
    sellDirectLeadToken: "",
    listingAgreementSignedAt: undefined,
    assignedAgent: undefined,
    listingActiveAt: undefined,
    listingSoldAt: undefined,
    assignedBrokerage: undefined,
    proposedBrokerage: undefined,
    assessmentScheduledAt: undefined,
    inAgentLedOffersExperience: false,
    exitedAloAt: undefined,
    listingEstimatePricingsId: "",
    sellerLeadUuid: "",
    listingId: "",
    addressUuid: "",
  };
}

export const LwcProductView = {
  fromJSON(object: any): LwcProductView {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      intent: isSet(object.intent) ? lwcProductView_IntentFromJSON(object.intent) : 0,
      sellDirectLeadToken: isSet(object.sellDirectLeadToken) ? String(object.sellDirectLeadToken) : "",
      listingAgreementSignedAt: isSet(object.listingAgreementSignedAt)
        ? fromJsonTimestamp(object.listingAgreementSignedAt)
        : undefined,
      assignedAgent: isSet(object.assignedAgent) ? AssignedAgent.fromJSON(object.assignedAgent) : undefined,
      listingActiveAt: isSet(object.listingActiveAt) ? fromJsonTimestamp(object.listingActiveAt) : undefined,
      listingSoldAt: isSet(object.listingSoldAt) ? fromJsonTimestamp(object.listingSoldAt) : undefined,
      assignedBrokerage: isSet(object.assignedBrokerage)
        ? AssignedBrokerage.fromJSON(object.assignedBrokerage)
        : undefined,
      proposedBrokerage: isSet(object.proposedBrokerage)
        ? AssignedBrokerage.fromJSON(object.proposedBrokerage)
        : undefined,
      assessmentScheduledAt: isSet(object.assessmentScheduledAt)
        ? fromJsonTimestamp(object.assessmentScheduledAt)
        : undefined,
      inAgentLedOffersExperience: isSet(object.inAgentLedOffersExperience)
        ? Boolean(object.inAgentLedOffersExperience)
        : false,
      exitedAloAt: isSet(object.exitedAloAt) ? fromJsonTimestamp(object.exitedAloAt) : undefined,
      listingEstimatePricingsId: isSet(object.listingEstimatePricingsId)
        ? String(object.listingEstimatePricingsId)
        : "",
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      listingId: isSet(object.listingId) ? String(object.listingId) : "",
      addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
    };
  },

  toJSON(message: LwcProductView): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.intent !== 0) {
      obj.intent = lwcProductView_IntentToJSON(message.intent);
    }
    if (message.sellDirectLeadToken !== "") {
      obj.sellDirectLeadToken = message.sellDirectLeadToken;
    }
    if (message.listingAgreementSignedAt !== undefined) {
      obj.listingAgreementSignedAt = message.listingAgreementSignedAt.toISOString();
    }
    if (message.assignedAgent !== undefined) {
      obj.assignedAgent = AssignedAgent.toJSON(message.assignedAgent);
    }
    if (message.listingActiveAt !== undefined) {
      obj.listingActiveAt = message.listingActiveAt.toISOString();
    }
    if (message.listingSoldAt !== undefined) {
      obj.listingSoldAt = message.listingSoldAt.toISOString();
    }
    if (message.assignedBrokerage !== undefined) {
      obj.assignedBrokerage = AssignedBrokerage.toJSON(message.assignedBrokerage);
    }
    if (message.proposedBrokerage !== undefined) {
      obj.proposedBrokerage = AssignedBrokerage.toJSON(message.proposedBrokerage);
    }
    if (message.assessmentScheduledAt !== undefined) {
      obj.assessmentScheduledAt = message.assessmentScheduledAt.toISOString();
    }
    if (message.inAgentLedOffersExperience === true) {
      obj.inAgentLedOffersExperience = message.inAgentLedOffersExperience;
    }
    if (message.exitedAloAt !== undefined) {
      obj.exitedAloAt = message.exitedAloAt.toISOString();
    }
    if (message.listingEstimatePricingsId !== "") {
      obj.listingEstimatePricingsId = message.listingEstimatePricingsId;
    }
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.listingId !== "") {
      obj.listingId = message.listingId;
    }
    if (message.addressUuid !== "") {
      obj.addressUuid = message.addressUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LwcProductView>, I>>(base?: I): LwcProductView {
    return LwcProductView.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LwcProductView>, I>>(object: I): LwcProductView {
    const message = createBaseLwcProductView();
    message.id = object.id ?? "";
    message.intent = object.intent ?? 0;
    message.sellDirectLeadToken = object.sellDirectLeadToken ?? "";
    message.listingAgreementSignedAt = object.listingAgreementSignedAt ?? undefined;
    message.assignedAgent = (object.assignedAgent !== undefined && object.assignedAgent !== null)
      ? AssignedAgent.fromPartial(object.assignedAgent)
      : undefined;
    message.listingActiveAt = object.listingActiveAt ?? undefined;
    message.listingSoldAt = object.listingSoldAt ?? undefined;
    message.assignedBrokerage = (object.assignedBrokerage !== undefined && object.assignedBrokerage !== null)
      ? AssignedBrokerage.fromPartial(object.assignedBrokerage)
      : undefined;
    message.proposedBrokerage = (object.proposedBrokerage !== undefined && object.proposedBrokerage !== null)
      ? AssignedBrokerage.fromPartial(object.proposedBrokerage)
      : undefined;
    message.assessmentScheduledAt = object.assessmentScheduledAt ?? undefined;
    message.inAgentLedOffersExperience = object.inAgentLedOffersExperience ?? false;
    message.exitedAloAt = object.exitedAloAt ?? undefined;
    message.listingEstimatePricingsId = object.listingEstimatePricingsId ?? "";
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.listingId = object.listingId ?? "";
    message.addressUuid = object.addressUuid ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
